import axios from 'axios'

const corevasAxios = axios.create({
  baseURL: process.env.VUE_APP_COREVAS_API_BASE_URL,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
  }
})

export { corevasAxios };
